module.exports = __webpack_public_path__ + "Roboto-Medium.2741a14e49524efa6059.woff2";


//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/roboto-fontface/fonts/roboto/Roboto-Medium.woff2
// module id = ../../../../roboto-fontface/fonts/roboto/Roboto-Medium.woff2
// module chunks = styles